import React from 'react';
import { Column } from 'material-table';
import { Button, createStyles, Dialog, DialogActions, DialogContent, FormControl, FormControlLabel, FormGroup,
    Grid, makeStyles, Switch, Typography } from '@material-ui/core';

import { BatchCorrectionContext } from '../BatchCorrectionContext';
import { categorizationColumnsArray, classificationColumnsArray, IBatchCorrectionTableColumn } from '../enum/BatchCorrectionFilterColumns';
import { BatchCorrectionSearchType } from '../enum/BatchCorrectionSearchType';
import { CategoryModelFullDto } from '../../../../Models/CategoryModelFullDto';
import { ClassificationModel } from '../../../../Models/ClassificationModel';

const useStyles = makeStyles(() => createStyles({    
    root: {
        maxWidth: '1152px',
        maxHeight: '90vh',
        padding: '0.5rem',
        borderRadius: '16px'
    }
}));

export function BatchCorrectionFilterColumnsDialog() {
    const classes = useStyles();

    const batchCorrectionContext = React.useContext(BatchCorrectionContext);

    const [showAllColumns, setShowAllColumns] = React.useState<boolean>(false);
    const [columnsToFilter, setColumnsToFilter] = React.useState<IBatchCorrectionTableColumn[]>([]);

    React.useEffect(() => {
        let columnsToDisplay: IBatchCorrectionTableColumn[] = [];

        if (batchCorrectionContext.searchType === BatchCorrectionSearchType.CLASSIFICATION)
            columnsToDisplay = [...classificationColumns];
        else if (batchCorrectionContext.searchType === BatchCorrectionSearchType.CATEGORIZATION)
            columnsToDisplay = [...categorizationColumns];

        columnsToDisplay.sort((a: IBatchCorrectionTableColumn, b: IBatchCorrectionTableColumn) => a.title.localeCompare(b.title));

        setColumnsToFilter(columnsToDisplay);
    }, [batchCorrectionContext.searchType]);

    React.useEffect(() => {
        if (batchCorrectionContext.filterColumnsDialogOpen)
            handleCheckSelectedTableColumns();
    }, [batchCorrectionContext.filterColumnsDialogOpen]);

    React.useEffect(() => {
        setShowAllColumns(columnsToFilter.findIndex(c => c.checked === false) < 0);
    }, [columnsToFilter]);

    const classificationColumns: IBatchCorrectionTableColumn[] = [...classificationColumnsArray];
    const categorizationColumns: IBatchCorrectionTableColumn[] = [...categorizationColumnsArray];

    const handleCheckSelectedTableColumns = () => {
        if (columnsToFilter && columnsToFilter.length > 0) {
            const filteredColumns = [...columnsToFilter];

            filteredColumns.forEach(fc => {
                const index = batchCorrectionContext.tableColumns.findIndex(tc => tc.title === fc.column.title);
                
                if (index >= 0)
                    fc.checked = true;
                else
                    fc.checked = false;
            });

            setColumnsToFilter(filteredColumns);
        }
    };
    
    const handleShowAllColumns = (event: React.ChangeEvent<HTMLInputElement>) => {
        const filteredColumns = [...columnsToFilter];
        filteredColumns.forEach(c => c.checked = event.target.checked);

        setShowAllColumns(event.target.checked);
        setColumnsToFilter(filteredColumns);
    };

    const handleDiscardChanges = () => {
        batchCorrectionContext.setFilterColumnsDialogOpen(false);
    };

    const handleFilterColums = () => {
        const columns = [...columnsToFilter];
        const selectedColumns: Column<ClassificationModel | CategoryModelFullDto>[] = [];

        batchCorrectionContext.tableColumns.forEach(tc => { 
            const index = columns.findIndex(c => c.column.title === tc.title);

            if (index > -1 && columns[index].checked) {
                selectedColumns.push(tc);
                columns.splice(index, 1);
            }
        });

        columns.forEach(c => {
            if (c.checked)
                selectedColumns.push(c.column);
        });

        batchCorrectionContext.setTableColumns(selectedColumns);
        batchCorrectionContext.setFilterColumnsDialogOpen(false);
    };

    const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const filterColumns = [...columnsToFilter];
        filterColumns[index].checked = event.target.checked;

        setColumnsToFilter(filterColumns);
    };

    const getFilters = () => {
        return(
            <FormControl component="fieldset">
                <FormGroup>
                    <Grid
                        container
                        direction="row"
                        justify="flex-start"
                        alignItems="flex-start"
                        wrap="wrap"
                        spacing={2}>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        color="primary"
                                        checked={showAllColumns}
                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleShowAllColumns(event)}
                                        name="show-all" />}
                                label={<Typography variant="subtitle2">Exibir todas as colunas</Typography>}
                            />
                        </Grid>
                        { populateColumns() }
                    </Grid>
                </FormGroup>
            </FormControl>
        );
    };

    const populateColumns = () => {
        return columnsToFilter.map((c, index) => {
            return(
                <Grid
                    item
                    key={c.title}
                    xs={4}>
                    <FormControlLabel
                        control={
                            <Switch
                                color="primary"
                                checked={c.checked}
                                onChange={(event) => handleSwitchChange(event,index)}
                                name={c.title} />}
                        label={<Typography variant="body2">{c.title}</Typography>}
                    />
                </Grid>
            );     
        });
    };
    
    const getButtons = () => {
        return (
            <Grid 
                container
                spacing={2}
                direction="row"
                justify="flex-end"
                alignItems="flex-end"
            >
                <Grid item>
                    <Button 
                        onClick={handleDiscardChanges} 
                        variant="outlined"
                        size="large">
                            DESCARTAR
                    </Button>
                </Grid>
                <Grid item>
                    <Button 
                        onClick={handleFilterColums} 
                        variant="contained" 
                        color="primary"
                        size="large">
                            FILTRAR
                    </Button>
                </Grid>
            </Grid>
        );
    };

    return (
        <Dialog 
            maxWidth='lg'
            aria-labelledby="filter-columns" 
            open={batchCorrectionContext.filterColumnsDialogOpen}>
            <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="stretch"
                className={classes.root}>
                <Grid item xs={12}>
                    <DialogContent>
                        { getFilters() }
                    </DialogContent>
                </Grid>
                <Grid item xs={12}>
                    <DialogActions>
                        { getButtons() }
                    </DialogActions>
                </Grid>
            </Grid>
        </Dialog>
    );
}